import { Quote } from "lucide-react";
import { BUSINESS } from "../data/site";

export const Testimonials = ({ fr = false }) => (
  <section className="py-16" data-testid="testimonials-section">
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
      <div className="w-12 h-12 mx-auto rounded-xl bg-[#FF9100]/10 border border-[#FF9100]/25 flex items-center justify-center text-[#FF9100] mb-5">
        <Quote className="w-6 h-6" />
      </div>
      <h2 className="font-heading text-2xl sm:text-3xl font-bold tracking-tight text-white mb-4">
        {fr ? "La Confiance de Nos Clients" : "Trusted by Our Clients"}
      </h2>
      <p className="text-gray-400 leading-relaxed max-w-2xl mx-auto">
        {fr
          ? "Nous recueillons présentement des témoignages écrits des entreprises, communautés et organisations que nous protégeons. Entre-temps, nous offrons volontiers des références sur demande — appelez-nous et nous vous mettrons en contact avec un client de votre secteur."
          : "We're currently gathering written reviews from the businesses, communities, and organizations we protect. In the meantime, we're glad to provide references on request — call us and we'll connect you with a client in your industry."}
      </p>
      <a
        href={BUSINESS.phoneHref}
        data-testid="testimonials-call-link"
        className="inline-flex items-center gap-2 mt-5 text-[#FF9100] font-semibold hover:underline"
      >
        {fr ? `Références sur demande : ${BUSINESS.phone}` : `References on request: ${BUSINESS.phone}`}
      </a>
    </div>
  </section>
);
